import React from "react";
import MultiStepForm from "./MultiStepForm";
// import { Link } from "react-router-dom";

export default function MotorInsurance() {
  return (
    <div>
      <div id="body-div">
        <MultiStepForm />
      </div>
    </div>
  );
}
